<template>
  <div class="page-cover flex-row justify-center" :class="aiTheme">
    <p class="mb-5 text-left" style="margin-top: 0" v-if="props.descContent">
      <span>关键词描述：</span>
      <span v-html="props.descContent"></span>
    </p>
  </div>
</template>
<script setup lang="ts">
import { useStorage } from "@vueuse/core/index";
import { defineProps, ref } from "vue";

const props = defineProps(["descContent"]);
const aiTheme = useStorage("ai-theme", "brown", localStorage);
const bofangIcon = ref("icon-bofang3");

</script>

<style>
ion-popover::part(content) {
  --width: none;
  max-width: 100vw;
}
</style>
<style scoped lang="less">
.page-cover{
  padding: 1rem 1.5rem;
  position: relative;
  text-align: left;
}
</style>